// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ id:0,label:'科室属性：',spanRows:12,type:'select',modelValue:'attributeName',op:'selectKsOptions' },
	{ id:1,label:'急诊：',spanRows:12,type:'select',modelValue:'applyEmergency',op:'emeOptions'},
	{ id:2,label:'挂号：',spanRows:12,type:'select',modelValue:'applyRegister',op:'regOptions'},
	{ id:3,label:'门诊：',spanRows:12,type:'select',modelValue:'applyOutpatient',op:'OutOptions'},
	// { id:4,label:'住院：',spanRows:12,type:'select',modelValue:'applyHospital',op:'HosOptions'},
]

